import React from "react";
import { Outlet } from "react-router-dom";

import { AuthLayoutContent, AuthLayoutWrapper } from "./styles";

/**
 * Компонент AuthLayout - обновленный макет для страниц аутентификации
 * Создает единое пространство для отображения форм входа, регистрации и восстановления пароля
 */
const AuthLayout: React.FC = () => {
  return (
    <AuthLayoutWrapper>
      <AuthLayoutContent>
        <Outlet />
      </AuthLayoutContent>
    </AuthLayoutWrapper>
  );
};

export default AuthLayout;
